import {
  Form,
  Input,
  Checkbox,
  Tooltip
} from "antd";
import { QuestionCircleIcon } from "components/Icons";

export function displayFooterCheckboxes({
    form,
    forceUpdate,
    itemType,
    options,
  }) {
    const enabledOptions = [];
    for (let optionName in options) {
      let enabledForItemTypes = options[optionName];
      if (enabledForItemTypes.includes(itemType)) {
        enabledOptions.push(optionName);
      }
    }
    if (enabledOptions.length === 0) {
      return null;
    }
  
    return (
      <div className="form-group">
        {enabledOptions.includes("asbestos") && (
          <div className="input-helper-wrapper">
            <div className="checkbox-textarea-group">
              <Form.Item
                key="checkboxes_asbestos"
                name="checkboxes_asbestos"
                valuePropName="checked"
                shouldUpdate
              >
                <Checkbox
                  onChange={(e) => {
                    form.setFieldsValue({
                      checkboxes_asbestos: e.target.checked,
                    });
                    if (!form.getFieldValue("checkboxes_asbestos")) {
                      form.setFieldsValue({
                        notes_asbestos: undefined,
                      });
                    }
                    forceUpdate();
                  }}
                >
                  Asbestos
                </Checkbox>
              </Form.Item>
              <Form.Item
                key="notes_asbestos"
                name="notes_asbestos"
                hidden={form.getFieldValue("checkboxes_asbestos") !== true}
                shouldUpdate
              >
                <Input.TextArea allowClear />
              </Form.Item>
            </div>
            <div className="checkbox-helper-wrapper">
              <Tooltip
                title="Checkbox activated free text field. Capture any asbestos information in relation to the asset."
                placement={'left'}
              >
                <div className="form-helper checkbox-note-helper">{/* the div around the Icon triggers the tooltip on hover */}
                  <QuestionCircleIcon />
                </div>
              </Tooltip>
            </div>
          </div>
          
        )}
        {enabledOptions.includes("hsIssue") && (
          <div className="input-helper-wrapper">
            <div className="checkbox-textarea-group">
              <Form.Item
                key="checkboxes_hsIssue"
                name="checkboxes_hsIssue"
                valuePropName="checked"
                shouldUpdate
              >
                <Checkbox
                  onChange={(e) => {
                    form.setFieldsValue({
                      checkboxes_hsIssue: e.target.checked,
                    });
                    if (!form.getFieldValue("checkboxes_hsIssue")) {
                      form.setFieldsValue({
                        notes_hsIssue: undefined,
                      });
                    }
                    forceUpdate();
                  }}
                >
                  Health {"&"} Safety
                </Checkbox>
              </Form.Item>
              <Form.Item
                key="notes_hsIssue"
                name="notes_hsIssue"
                hidden={form.getFieldValue("checkboxes_hsIssue") !== true}
                shouldUpdate
              >
                <Input.TextArea allowClear />
              </Form.Item>
            </div>
            <div class="checkbox-helper-wrapper">
              <Tooltip
                title="Checkbox activated free text field. Capture any health and safety issues in relation to the asset."
                placement={'left'}
              >
                <div className="form-helper checkbox-note-helper">{/* the div around the Icon triggers the tooltip on hover */}
                  <QuestionCircleIcon />
                </div>
              </Tooltip>
            </div>
          </div>
        )}
        {enabledOptions.includes("reminder") && (
          <div className="input-helper-wrapper">
            <div className="checkbox-textarea-group">
              <Form.Item
                key="checkboxes_reminder"
                name="checkboxes_reminder"
                valuePropName="checked"
                shouldUpdate
                rules={[
                  {
                    required:
                      form.getFieldValue("status") === "INACCESSIBLE" ? true : false,
                    message: "Status Inaccessible, please add a Note",
                  },
                ]}
              >
                <Checkbox
                  onChange={(e) => {
                    form.setFieldsValue({
                      checkboxes_reminder: e.target.checked,
                    });
                    if (!e.target.checked) {
                      form.setFieldsValue({
                        notes_reminder: undefined,
                      });
                    }
                    forceUpdate();
                  }}
                >
                  Surveyor Notes
                </Checkbox>
              </Form.Item>
              <Form.Item
                key="notes_reminder"
                name="notes_reminder"
                hidden={form.getFieldValue("checkboxes_reminder") !== true}
                shouldUpdate
                rules={[
                  {
                    required:
                      form.getFieldValue("status") === "INACCESSIBLE" &&
                      form.getFieldValue("checkboxes_reminder")
                        ? true
                        : false,
                    message: "Please insert a Note",
                  },
                ]}
              >
                <Input.TextArea allowClear />
              </Form.Item>
            </div>
            <div className="checkbox-helper-wrapper">
              <Tooltip
                title="Checkbox activated free text field. Capture any information in relation to the asset data capture to assist with review at a later point. For internal purposes only and are not included in the asset register. e.g. asset access, how infomation has been captured if not from the physical asset etc."
                placement={'left'}
              >
                <div className="form-helper checkbox-note-helper">{/* the div around the Icon triggers the tooltip on hover */}
                  <QuestionCircleIcon />
                </div>
              </Tooltip>
            </div>
          </div>
        )}
      </div>
    );
  }
  